export default {
  error: {
    resultsSending: 'خطأ عند إرسال النتائج'
  }
}
